(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-gvx-shell]').forEach((shell) => {
      if (shell.dataset.gvxShopReady) return;
      shell.dataset.gvxShopReady = 'true';
      const shop = shell.querySelector('[data-gvx-shop-menu]');
      if (!shop) return;
      const summary = shop.querySelector('summary');
      const close = (restore = false) => {
        if (!shop.open) return;
        shop.open = false;
        if (restore) summary.focus();
      };
      summary.addEventListener('click', () => {
        if (!shop.open) {
          const mega = shell.querySelector('[data-gvx-mega]');
          if (mega && !mega.hidden) mega.querySelector('[data-gvx-mega-close]')?.click();
          window.themeCore?.EventBus?.emit('Toggle:searchTogglePopup:close');
        }
      });
      shell.querySelectorAll('[data-gvx-mega-toggle], [data-gvx-mobile-toggle], [data-js-toggle="searchTogglePopup"]').forEach((button) => button.addEventListener('click', () => close()));
      document.addEventListener('click', (event) => { if (!shop.contains(event.target)) close(); });
      shop.addEventListener('keydown', (event) => { if (event.key === 'Escape') { event.preventDefault(); close(true); } });
      shop.addEventListener('focusout', (event) => { if (event.relatedTarget && !shop.contains(event.relatedTarget)) close(); });
      shell.querySelectorAll('[data-gvx-mobile-category]').forEach((group) => {
        group.addEventListener('toggle', () => {
          if (group.open) shell.querySelectorAll('[data-gvx-mobile-category]').forEach((other) => { if (other !== group) other.open = false; });
        });
      });
      window.matchMedia('(max-width:989px)').addEventListener('change', () => close());
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
